import React from 'react';
import PropTypes from 'prop-types';
import uuidv1 from 'uuid/v1';
import classnames from 'classnames';
import withStyles from '@material-ui/core/styles/withStyles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { capitalize } from 'helpers/utils';
import Feedback from '@material-ui/icons/Feedback';
import Tooltip from '@material-ui/core/Tooltip';

const styles = theme => ({
  container: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(),
  },
  topContainer: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    fontSize: '0.9em',
    fontWeight: 'bold',
    color: '#000',
    marginBottom: 5,
  },
  msgWarning: {
    color: '#e68a00',
  },
  msgError: {
    color: '#ff0000',
  },
  pointer: {
    cursor: 'pointer',
  },
});

export const Messages = props => {
  const { classes, messages, showPackageErrors } = props;

  return (
    <div className={classes.container}>
      <div className={classes.topContainer}>
        <div className={classes.title}>Compliance report</div>
      </div>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>Level</TableCell>
            <TableCell>Message</TableCell>
            <TableCell>Type</TableCell>
            <TableCell numeric />
          </TableRow>
        </TableHead>
        <TableBody>
          {messages &&
            messages.map(msg => (
              <TableRow key={uuidv1()} hover>
                <TableCell
                  component="th"
                  scope="row"
                  className={
                    msg.level.toUpperCase() === 'WARNING'
                      ? classes.msgWarning
                      : classes.msgError
                  }
                >
                  {capitalize(msg.level)}
                </TableCell>
                <TableCell>{capitalize(msg.message)}</TableCell>
                <TableCell>
                  {msg.type.toLowerCase() === 'wcag2aa' ? 'Accessibility' : msg.type}
                </TableCell>
                <TableCell>
                  {msg.metadata && (
                    <Tooltip title="View detailed feedback">
                      <Feedback
                        className={classnames(classes.pointer, classes.msgWarning)}
                        style={{ fontSize: 24 }}
                        onClick={() => {
                          showPackageErrors(msg.metadata);
                        }}
                      />
                    </Tooltip>
                  )}
                </TableCell>
              </TableRow>
            ))}
          {!messages && <TableRow />}
        </TableBody>
      </Table>
    </div>
  );
};

Messages.propTypes = {
  classes: PropTypes.object.isRequired,
  messages: PropTypes.array,
};

export default withStyles(styles)(Messages);
